var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelTiktok14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.556 6.046a2.67 2.67 0 0 1-2.48-1.195v4.11a3.038 3.038 0 1 1-3.038-3.037q.096.001.188.01V7.43c-.062-.007-.124-.018-.188-.018a1.55 1.55 0 0 0 0 3.1c.857 0 1.613-.674 1.613-1.53L7.666 2h1.432a2.67 2.67 0 0 0 2.46 2.382v1.664"
}))));
export default SvgChannelTiktok14;